import { siteSelection } from '../../common/adUtils';
import { reloadQSI } from "../../../../../../utils/common";
import { circuitNameClick } from "../../../../../../utils/common";
import { tViews } from "../../../../../../utils/table";

export const getColumns = (
  saveUsageCipProps,
  setSelection,
  selection,
  setSelectedSite,
  circuitsMasterTable,
  navigate,
  openTableSettings
) => {
  return [
        {
          id: "display_circuit_name_col",
          prop: "display_circuit_name",
          get name() { return tViews('usageAnomalySummary.column_label.circuitName')},
          sortable: true,
          size: 180,
          cellTemplate: (h, prop) => {
            let rowData = circuitsMasterTable?.data?.find((item) => item.circuit_display_name === prop.model.display_circuit_name);
            const checkBox =  h("hbr-radio", {
              checked: selection === prop.model.id,
              "onHbr-click": () => {
                setSelection(prop.model.id);
                saveUsageCipProps({
                  circuitName: prop.model.circuit_name,
                  site: prop.model.site_id,
                  displayCircuitName: prop.model.display_circuit_name,
                  displaySiteName: prop.model.site_name,
                });
                // Load Qualtrics Intercept.
                reloadQSI();
              },
              "aria-label": tViews('a11yLabels.selectCircuitwithName' , {circuitName: prop.model.display_circuit_name}),
              "data-testid": "anomaly-summary-circuit-radio",
              role: "radio"
            });
            const link = h("hbr-link", {
              id: "circuit-link",
              "data-testid":"anomaly-summary-circuit-link",
              "onClick": (e) => {
                e.preventDefault();
                rowData && circuitNameClick(navigate, rowData);
              },
              "onKeyDown": (e) => {
                // Trigger action on Enter or Space key
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  rowData && circuitNameClick(navigate, rowData);
                }
              },
              "aria-label": tViews('a11yLabels.forSearchCircuit' , {circuitName: prop.model.display_circuit_name}),
              role: "link"
            }, prop.model.display_circuit_name);
            const content = h("div", {
              id: "ciu-div-checkbox-link",
            }, [checkBox, link]);
            return content;
          },
        },
        { 
          id: "site_name_col",
          prop: "site_name",
          get name() { return tViews('usageAnomalySummary.column_label.siteName')},
          sortable: true,
          size: 150,
          cellTemplate: (createElement, prop) => {
            return createElement("hbr-link", 
            {
              "onClick": (e) => {
                e.preventDefault();
                siteSelection(prop.model, navigate, setSelectedSite);
              },
              "onKeyDown": (e) => {
                // Trigger action on Enter or Space key
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  siteSelection(prop.model, navigate, setSelectedSite);
                }
              },
              "data-testid": "anomaly-summary-site-link",
              "aria-label": tViews('a11yLabels.forSitename', {siteName: prop.model.site_name}),
              role: "link"
            }, prop.model.site_name);
          }
        },
        { 
          id: "site_city_col",
          prop: "site_city",
          get name() { return tViews('usageAnomalySummary.column_label.siteCity')},
          sortable: true,
          size: 130
        },
        { 
          id: "display_circuit_usage_col",
          prop: "display_circuit_usage",
          get name() { return tViews('usageAnomalySummary.column_label.circuitUsage')},
          sortable: true,
          size: 150
        },
        { 
          id: "display_tunnel_usage_col",
          prop: "display_tunnel_usage",
          get name() { return tViews('usageAnomalySummary.column_label.tunnelUsage')},
          sortable: true,
          size: 150
        },
        { 
          id: "display_dia_usage_col",
          prop: "display_dia_usage",
          get name() { return tViews('usageAnomalySummary.column_label.diaUsage')},
          sortable: true,
          size: 130
        },
        {
          id: "display_sig_usage_col",
          prop: "display_sig_usage",
          get name() { return tViews('usageAnomalySummary.column_label.sigUsage')},
          sortable: true,
          size: 130
        },
        { 
          id:"app_cnt_col",
          prop: "app_cnt",
          get name() { return tViews('usageAnomalySummary.column_label.applications')},
          sortable: true,
          size: 120
        },
        { 
          id: "user_cnt_col",
          prop: "user_cnt",
          get name() { return tViews('usageAnomalySummary.column_label.users')},
          sortable: true,
          size: 100
        },
        {
          id: "actions_col",
          prop: "actions",
          name: "Actions",
          hiddenText: "Actions",
          disableToggle: true,
          sortable: false,
          headerSlot: false,
          pin: "colPinEnd",
          size: 70,
          columnTemplate: (createElement) => {
            return createElement("hbr-icon-button", {
              name: "gear-six-outlined",
              class: "hbr-css__table-cell-align-center gear-icon",
              aria: { label: tViews('tableSettings') || "Table settings" },
              "data-testid": "setting-ad-summary-table",
              onClick: (evt) => {
                evt.stopPropagation();
                openTableSettings();
              }
            });
          }
        }
    ]
}
